import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4cdae580"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "account-safety"
};
const _hoisted_2 = {
  class: "top-content"
};
import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';
import { getUserInfoApi } from '@/api/personalInfo';
// const route = useRoute()
export default /*#__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {
    const router = useRouter();
    // const mobiles = ref('')
    const accountNames = ref('');
    const showAccountNames = ref('');
    // const phone = ref('')
    // const mobile = ref('')
    const clickChangepwd = () => {
      router.push({
        path: '/changePassword',
        query: {
          phoneNum: accountNames.value,
          phoneNumhHideen: showAccountNames.value
        }
      });
    };
    const clickChangephone = () => {
      router.push({
        path: '/changePhoneNumber',
        query: {
          phoneNum: accountNames.value,
          phoneNumhHideen: showAccountNames.value
        }
      });
      // router.push({
      //     name: 'changePhoneNumber',
      //     params: {
      //         phoneNum: mobiles.value,
      //     },
      // })
    };

    const userInfo = async () => {
      const {
        code,
        message,
        data
      } = await getUserInfoApi();
      if (code === 9000) {
        // mobiles.value = data.mobile
        accountNames.value = data.accountName;
        showAccountNames.value = data.showAccountName;
        console.log('accountNames', accountNames.value, 'showAccountNames', showAccountNames.value);
        // phone.value = mobiles.value.substr(0, 3) + '****' + mobiles.value.substr(7)
      }
    };

    onMounted(() => {
      userInfo();
    });
    return (_ctx, _cache) => {
      const _component_van_cell = _resolveComponent("van-cell");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_cell, {
        title: "修改密码",
        "is-link": "",
        onClick: clickChangepwd
      }), _createVNode(_component_van_cell, {
        title: "更改手机",
        "is-link": "",
        onClick: clickChangephone
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(accountNames.value), 1)]),
        _: 1
      })])]);
    };
  }
});